import { render, staticRenderFns } from "./m_highlightcorrectsummary.vue?vue&type=template&id=f8c63ac8&scoped=true&"
import script from "./m_highlightcorrectsummary.vue?vue&type=script&lang=js&"
export * from "./m_highlightcorrectsummary.vue?vue&type=script&lang=js&"
import style0 from "./m_highlightcorrectsummary.vue?vue&type=style&index=0&id=f8c63ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c63ac8",
  null
  
)

export default component.exports